import type { RootState } from '~publish/legacy/store'

import type { IntegrationImport } from './integrationBarSlice'

export const selectIsIntegrationUploading = (state: RootState): boolean =>
  state.integrationBar.inFlightCount > 0

export const selectIntegrationImport = (
  state: RootState,
): IntegrationImport | null => state.integrationBar.activeImport
